
export {} from '../../../frontend-js-react-web/__liferay__/exports/classnames.js';
import __x__ from '../../../frontend-js-react-web/__liferay__/exports/classnames.js';export default __x__;